var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"well-graphical-segmentations"},[_c('canvas',{ref:"canvas",staticClass:"w-100 h-100"})])}
var staticRenderFns = []
export { render, staticRenderFns }